'use client';

import { Box, Loader } from '@mantine/core';

export default function Loading() {
  return (
    <Box className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 backdrop-blur-sm dark:bg-secondary-800/60">
      <Loader color="#bf9d3b" type="bars" size="lg" />
    </Box>
  );
}
